﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export const useStyles = createUseStyles((theme: ConsilioBaseTheme) => ({
    title: {
        margin: "auto",
    },

    confirmPhoneGrid: {
        "@media (orientation : landscape)": {
            gridTemplateColumns: "250px 150px",
        },
    },

    buttons: {
        display: "flex",
        flexDirection: "row",
        "& div": {
            display: "flex",
            flex: "1",
        },
        "& div div": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },
}));
